import { h } from "preact";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const CredentialCriteria = ({ criteria }) => {
  if (!criteria || criteria.length === 0) return null;

  return (
    <article>
      <p class="text-lg py-2">CRITERIOS</p>
      <div class="w-full rounded-lg bg-[#FFF] p-5 my-3">
        {criteria.map((criterion) => (
          <p class="mb-5 flex items-start">
            <IoMdCheckmarkCircleOutline class="mt-1 w-5 h-5 mr-2 align-top shrink-0" />
            <span class="">{criterion}</span>
          </p>
        ))}
      </div>
    </article>
  );
};

export default CredentialCriteria;
